
import React from "react";
import Modal from "./modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import cookie from "react-cookies";
import { UNIFIED_BASE_URL, WEB_BASE_URL } from "./webbase";

class Users extends React.Component {
  constructor() {
    super();
    this.state = {
      userEmail: cookie.load("user"),
      role: cookie.load("role"),
      token: cookie.load("token"),
      users: [],
      email: '',
      formRole: '',
      transactionPin: ''
    };
    // console.log(token);
    
  }

  componentDidMount() {
    this.getUsers();
  }

  
  getUsers = () => {
    axios
      .get(WEB_BASE_URL + "/admin/get-all-users", {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        this.setState({ users: res.data.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

// onInviteUser = (event) => {
//   event.preventDefault();

//   const { email, formRole, transactionPin, token } = this.state;

//   if (!email || !formRole || !transactionPin) {
//     toast.error("All fields are required!");
//     return;
//   }

//   axios
//     .post(
//       WEB_BASE_URL + "/admin/change-role",
//       {
//         emailAddress: email,
//         newRole: formRole,
//         transactionPin: transactionPin,
//       },
//       {
//         headers: {
//           Authorization: token,
//           'Content-Type': 'application/json',
//         },
//       }
//     )
//     .then((res) => {
//       // Check if API returns a custom error code inside the response
//       if (res.data?.code === 4000) {
//         toast.error(res?.data?.message || "An error occurred");
//       } else if (res.status === 200) {
//         toast.success("User Role Changed Successfully!");
//         this.getUsers();
//         this.setState({ formRole: '', transactionPin: '' });
//       } else {
//         toast.error("Unexpected response from server.");
//       }
//     })
//     .catch((err) => {
//       console.error(err);
//       // Optional: try to extract error message
//       const message =
//         err?.response?.data?.message ||
//         "Failed to change role!";
//       toast.error(message);
//     });
// };
onInviteUser = (event) => {
  event.preventDefault();

  const { email, formRole, transactionPin, token } = this.state;

  if (!email || !formRole || !transactionPin) {
    toast.error("All fields are required!");
    return;
  }

  axios
    .post(
      WEB_BASE_URL + "/admin/change-role",
      {
        emailAddress: email,
        newRole: formRole,
        transactionPin: transactionPin,
      },
      {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      }
    )
    .then((res) => {
      const { status, description } = res.data;

      if (status === "2000") {
        toast.success(description || "Role changed successfully");
        this.getUsers();
        this.setState({ formRole: '', transactionPin: '' });
      } else {
        toast.error(description || "An error occurred");
      }
    })
    .catch((err) => {
      console.error(err);
      const message = err?.response?.data?.description || "Failed to change role!";
      toast.error(message);
    });
};

  onChangeRole = (event) => {
    this.setState({ formRole: event.target.value });
  };

 
  onChangeTransactionPin = (event) => {
    this.setState({ transactionPin: event.target.value });
  };

  render() {
    return (
      <main className="page-content">
        <ToastContainer position="top-center" autoClose={3000} />

        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <a href="javascript:;">
                    <i className="bx bx-home-alt"></i>
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  All Admin Users
                </li>
              </ol>
            </nav>
          </div>
          <div className="ms-auto">
            <div className="btn-group">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#addModal"
              >
                Invite New User
              </button>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <h5 className="mb-0">All Admin Users</h5>
              <form className="ms-auto position-relative">
                <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                  <i className="bi bi-search"></i>
                </div>
                <input
                  className="form-control ps-5"
                  type="text"
                  placeholder="search"
                />
              </form>
            </div>

            <div className="table-responsive mt-3">
              <table className="table align-middle">
                <thead className="table-secondary">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    {this.state.role === "TOPUPBOX_ADMIN" ? <th>Actions</th> : null}
                  </tr>
                </thead>
                <tbody>
                  {this.state.users.map((user, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="d-flex align-items-center gap-3 cursor-pointer">
                          <div>
                            <p className="mb-0">
                              {user.firstName} {user.lastName}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>{user.emailAddress}</td>
                      <td>{user.userRole}</td>
                      {this.state.role === "TOPUPBOX_ADMIN" ? (
                        <td>
                          <div className="table-actions d-flex align-items-center gap-3 fs-6">
                            <a
                              href="javascript:;"
                              className="text-warning"
                              data-bs-toggle="modal"
                              data-bs-target="#editModal"
                              title="Edit"
                              onClick={() => {
                                this.setState({ email: user.emailAddress });
                              }}
                            >
                              <i className="bi bi-pencil-fill"></i>
                            </a>

                            <a
                            href="javascript:;"
                            className="text-danger"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="deactivate"
                          >
                            <i className="bi bi-toggle-on"></i>
                          </a>

                          </div>
                        </td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Modal for Editing User */}
              <div
                className="modal fade"
                id="editModal"
                tabIndex="-1"
                aria-labelledby="editModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="editModalLabel">
                        Edit User Role
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <form onSubmit={this.onInviteUser}>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            value={this.state.email}
                            readOnly
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">New Role</label>
                          <select
                            className="form-select"
                            value={this.state.formRole}
                            onChange={this.onChangeRole}
                          >
                            <option value="">Select Role</option>
                            <option value="DEALER">DEALER</option>
                            <option value="MANAGER">MANAGER</option>
                            <option value="ADMINISTRATOR">ADMINISTRATOR</option>
                            <option value="ACCOUNT_OFFICER">ACCOUNT_OFFICER</option>
                            <option value="POP_MANAGER">POP_MANAGER</option>
                            <option value="MERCHANT">MERCHANT</option>
                            <option value="VAS_MERCHANT">VAS_MERCHANT</option>
                            <option value="OPERATOR">OPERATOR</option>
                            <option value="TOPUPBOX_ADMIN">TOPUPBOX_ADMIN</option>
                            <option value="TOPUPBOX_MANAGER">TOPUPBOX_MANAGER</option>
                            <option value="TOPUPBOX_OPERATOR">TOPUPBOX_OPERATOR</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Transaction Pin</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Enter transaction pin"
                            value={this.state.transactionPin}
                            onChange={this.onChangeTransactionPin}
                          />
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-primary">
                          Effect Role Change
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* Toast Container already present at top */}
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default Users;
